import type { ImgHTMLAttributes } from 'react';

export type SmileyKind = 'sad' | 'happy';

const IMAGE_BASE_URL = 'https://npstoday.blob.core.windows.net/images';

const SMILEYS: Record<SmileyKind, { file: string; alt: string; side: 'left' | 'right' }> = {
  sad: { file: 'Smileys/Smiley-Sad-Face.png', alt: 'frown', side: 'left' },
  happy: { file: 'Smileys/Smiley-Very-Happy.png', alt: 'smile', side: 'right' }
};

export const smileyImageProps = (kind: SmileyKind): ImgHTMLAttributes<HTMLImageElement> => {
  const { file, alt, side } = SMILEYS[kind];
  return {
    src: `${IMAGE_BASE_URL}/${file}`,
    alt,
    width: 25,
    height: 25,
    style: { display: 'block', marginLeft: side === 'right' ? 'auto' : 0 }
  };
};

export const createSmileyImage = (kind: SmileyKind): HTMLImageElement => {
  const { style, ...attributes } = smileyImageProps(kind);
  const img = document.createElement('img');
  Object.assign(img, attributes);
  Object.assign(img.style, style);
  return img;
};
